angular
	.module('advanceCheckbox.components', [])
	.component('advanceCheckbox', {
		templateUrl: 'ng/components/advanceCheckbox/advanceCheckbox.html',
		bindings: {
			ischecked: '=',
			title: '@',
			myfunction: '=?',
			param: '=',
			bindingVariable: '=',
			disabled: '=',
			checkboxId: '@',
			checkboxClass: '@',
			multiline: '<',
			inputId: '@',
			labelClass: '@?',
			visualChecked: '<',
			tableHead: '<'
		},
		controllerAs: 'advanceCheckboxCtrl',
		controller: function ($scope) {

			//Not to loose the *this reference
			var self = this;
			//console.log(self);
			$scope.myfunction = $scope.$parent.myfunction;
			/**
			 * Init bindings here
			 */
			self.$onInit = function () {
			}



		}
	});